import {
  NotificationDataType,
  NotificationNormalizedDataType
} from '../Types/notification.type';

export const normalizeNotificationData = (
  data: NotificationDataType[]
): NotificationNormalizedDataType => {
  const normalizedData = {};
  data.forEach((item) => {
    const newDate = new Date(item.dateTime);
    const updatedItem = {
      ...item,
      date: newDate.toLocaleString('fa-IR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        calendar: 'persian',
        weekday: 'long'
      })
    };
    if (!normalizedData[updatedItem.date])
      normalizedData[updatedItem.date] = [];
    normalizedData[updatedItem.date].push(item);
  });
  return normalizedData;
};
